import {
    GoogleMap,
    SeaLevelMapWidget,
    WeatherMapRedesign,
} from '@/modules/map/widgets'
import { useEffect, useMemo, useState } from 'react'
import { ArticleWidget } from '@/modules/article/widgets'
import { LegendRisk, SliderControlSea } from '@/modules/map/components'
import {
    useEventsListener,
    useRisksCategory,
    // useSocketListener,
} from '@/core/hooks'
import { useGetCountries } from '@/modules/map/hooks/use-get-countries.hook'
import _ from 'lodash'
// import {
//     SubscribeRedesignPage,
//     TariffPlansRedesignPage,
// } from '@/modules/subscribe/pages'
import { SubcategoryRisks } from '@/core/typing'
import { useSearchCityStore, useSearchCountryStore } from '@/store'
import { useAccount } from '@/modules/user/hooks'
import { LayoutPageAtom } from './atoms'
import styles from './styles.module.css'
import { ChatBotWidget } from '@/modules/chat-bot/widgets'
// import { GuidoBot } from '@/modules/chat-bot/components'
// import {
//     FullNotiicationsWidget,
//     SettingsNotiificationsModalWidget,
// } from '@/modules/notifications/widgets'
import { RequrementsWidget } from '@/modules/entry-requirements/widgets/requirements'
import { AccountPage } from '@/modules/user/pages'
import { IntroStepMobileWidget, IntroStepsWidgets } from '@/core/widgets'
import {
    GreetingTravy,
    // StatusPayment
} from '@/core/components'
// import { appEvents } from '@/core/events'
import { AboutUsWidget, FaqsListWidget, FAQsWidget } from '@/modules/FAQ'
import { isNewCategory } from '@/modules/risks/helpers'
import { NaturalMap } from '@/modules/map/widgets/natural-map'
import { GuidoBot } from '@/modules/chat-bot/components'
// import { SubscriptionPlansBtnWhite } from '@/modules/subscribe/components'
// import { PaymentPage } from '@/modules/payment'
// import { sendEvent } from '@/core/services'
// import {
//     priceTariffs,
//     subscribeLabel,
// } from '@/modules/subscribe/configs/advantes.config'

export const MainPage = () => {
    const defValue = localStorage.getItem('BAR')

    const legend = localStorage.getItem('LEGEND')
    const [isOpen, setIsOpen] = useState(JSON.parse(defValue || 'true'))
    const [openAtricle, setOpenArticle] = useState(false)
    const { active } = useRisksCategory()
    const { setCountry } = useSearchCountryStore()
    const { countriesPlaceIds, countryList } = useGetCountries()
    const { account } = useAccount()
    const { clearCity } = useSearchCityStore()

    const [countryCode, setCountryCode] = useState<{
        code: string
        longName: string
    }>(null)
    const [borderMap, setBorderMap] = useState<boolean>()

    useEffect(() => {
        clearCity()
    }, [active])

    useEventsListener('intro', data => setBorderMap(data.isShow), [])

    // useSocketListener('subscription/new', () => {
    //     appEvents.emit('account', { isShow: false })
    //     appEvents.emit('payment', {
    //         isShow: false,
    //         intent: null,
    //         subscription: null,
    //         isTrial: null,
    //     })
    //     appEvents.emit('statusPayment', {
    //         isShow: true,
    //         status: 'succesed',
    //         message: 'usePlatform',
    //         isIntro: true,
    //     })
    //     sendEvent('successful_subscription', {
    //         subscription_plan: subscribeLabel[account?.subscription?.type],
    //         subscription_price: priceTariffs[account?.subscription?.type],
    //     })
    //     getAccount()
    // })

    // useSocketListener('subscription/changed', () => {
    //     getAccount()
    //     sendEvent('successful_subscription', {
    //         subscription_plan: subscribeLabel[account?.subscription?.type],
    //         subscription_price: priceTariffs[account?.subscription?.type],
    //     })
    // })

    // useSocketListener(
    //     'subscription/cancelled',
    //     () => {
    //         getAccount()
    //     },
    //     [],
    // )

    // useSocketListener(
    //     'subscription/switch-product-application',
    //     () => {
    //         appEvents.emit('statusPayment', {
    //             isShow: true,
    //             status: 'received',
    //             message: 'downgradeSubscribtionMessage',
    //         })
    //     },
    //     [],
    // )

    const handleChangeDrawer = (val: boolean) => setOpenArticle(val)

    const handleChangeCode = (val: { code: string; longName: string }) => {
        setCountryCode(val)
        setOpenArticle(!!active?.subcategory || isNewCategory(active?.category))
    }

    useEffect(() => {
        if (_.isNil(defValue)) {
            localStorage.setItem('BAR', JSON.stringify(true))
        }
        if (_.isNil(legend)) {
            localStorage.setItem('LEGEND', JSON.stringify(true))
        }
    }, [defValue, legend])

    useEffect(() => {
        setCountry(null)
    }, [active])

    useEffect(() => {
        setCountryCode(null)
    }, [active?.subcategory])

    const toggleSidebar = (val: boolean) => {
        setIsOpen(val)
        localStorage.setItem('BAR', String(val))
    }

    const legendRisk = useMemo(() => {
        if (active?.subcategory === SubcategoryRisks.Weather) {
            return null
        } else if (active?.subcategory === SubcategoryRisks.SeaLevelRise) {
            return <SliderControlSea />
        }
        return <LegendRisk />
    }, [active, length])

    const map = useMemo(
        () => ({
            google: (
                <GoogleMap
                    countriesList={countriesPlaceIds}
                    setCountryCode={handleChangeCode}
                />
            ),
            weather: <WeatherMapRedesign />,
            seaLevel: <SeaLevelMapWidget />,
            requirements: <NaturalMap />,
        }),
        [active, countriesPlaceIds],
    )

    const chatBot = useMemo(() => {
        if (!account) return null
        return <GuidoBot />
    }, [account])

    // const explorePlan = useMemo(() => {
    //     if (!account) {
    //         return null
    //     }
    //     return (
    //         <SubscriptionPlansBtnWhite
    //             onClick={() =>
    //                 appEvents.emit('subsribe', {
    //                     isShow: true,
    //                     method: 'buy',
    //                     isUpdate: true,
    //                 })
    //             }
    //         />
    //     )
    // }, [account])
    return (
        <div className={styles.container}>
            <LayoutPageAtom
                borderMap={borderMap}
                isOpenBar={isOpen}
                openSideBar={toggleSidebar}
                legendRisk={legendRisk}
                map={map}
                active={active}
                chatBot={chatBot}
            />
            {borderMap ? (
                <div id='profile' className={styles.account_tutorial} />
            ) : null}
            {countryList?.some(it => it?.countryCode === countryCode?.code) ? (
                <ArticleWidget
                    categoryGroup={active}
                    open={openAtricle}
                    onChangeDrawer={handleChangeDrawer}
                    countryCode={countryCode}
                />
            ) : null}

            <IntroStepsWidgets />
            <ChatBotWidget />
            <FAQsWidget />
            {/* <FullNotiicationsWidget /> */}
            {/* <SubscribeRedesignPage /> */}
            <RequrementsWidget />
            {/* <SettingsNotiificationsModalWidget /> */}
            <AccountPage />
            <GreetingTravy />
            <IntroStepMobileWidget />
            <FaqsListWidget />
            {/* <TariffPlansRedesignPage /> */}
            <AboutUsWidget />
            {/* <PaymentPage /> */}
            {/* <StatusPayment /> */}
            {/* {explorePlan} */}
        </div>
    )
}
